import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { Lud } from "src/app/shared/model/lud.model";
import { BancoRecursos } from "src/app/shared/util/banco-recursos.util";

@Component({
    selector: 'app-painel1-confeccao',
    templateUrl: './painel1-confeccao.component.html',
    styleUrls: ['./painel1-confeccao.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class Painel1ConfeccaoComponent implements OnChanges {
    @Input() ludSelecionado: Lud | null;
    @Input() bancoRecursos: BancoRecursos;
    @Input() isGerirRecursos: boolean;
    @Output() ludConfirmado = new EventEmitter<Lud | null>();

    url: string;
    fragmento: string;
    dispositivo: string;
    linkInternoNormas = false;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['ludSelecionado']) {
            const novo = changes['ludSelecionado'].currentValue as Lud;
            if (novo) {
                if (novo.idAto) {
                    this.linkInternoNormas = novo.url.indexOf('/intern') >= 0;
                }
                this.url = novo.url;
                this.fragmento = novo.fragmento;
                this.dispositivo = novo.dispositivo;
            } else {
                this.limparCampos();
            }
        }
    }

    limparCampos() {
        this.url = '';
        this.fragmento = '';
        this.dispositivo = '';
        this.linkInternoNormas = false;
    }

    alternarUrlNormas() {
        if (this.ludSelecionado && this.ludSelecionado.idAto) {
            this.linkInternoNormas = !this.linkInternoNormas;
            if (this.linkInternoNormas) {
                this.url = this.bancoRecursos.obterUrlNormasInterno(this.ludSelecionado.idAto);
            } else {
                this.url = this.bancoRecursos.obterUrlNormasExterno(this.ludSelecionado.idAto);
            }
            this.confeccionarLud();
        }
    }

    public testarUrl() {
        let url = this.url;
        if (this.fragmento) {
           url = url + '#' + this.fragmento
        }
        window.open(url, 'teste-url-normas');
    }

    public confeccionarLud() {
        const lud = Lud.criarLudDoUrlEFragmento(this.url, this.fragmento);
        this.ludConfirmado.emit(lud);
    }

    public descartarLud() {
        this.limparCampos();
        this.ludSelecionado = null;
        this.ludConfirmado.emit(null);
    }

    public verificarUrlNaoInformado() {
        return !this.url || this.url.trim().length === 0;
    }
}